import React, {useEffect, useState} from 'react';
import { Segmented, Card } from 'antd';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import '../../App.css';
import './Ai.css';
import aiData from './Ai_data';
import AiModel from "./AiModel";

const Ai = () => {
    const { Meta } = Card;
    const [showData, setShowData] = useState([]);
    const segmentedOptions = aiData.map(item => item.name); // 给集合对象中赋值

    useEffect(() => {
        // 初始化显示第一个服务的数据
        const defaultService = aiData.find(item => item.name === aiData[0].name);
        if (defaultService) {
            setShowData(defaultService.data);
        }
    }, []);

    // 处理 Segmented 切换
    const handleSegmentedChange = (value) => {
        setShowData([]); // 先清空一下，然后再赋值，这样页面体验要好一些。
        const selected = aiData.find(item => item.name === value);
        if (selected) {
            setShowData(selected.data);
        }
    };

    // 打开Modal框
    const [modalVisible, setModalVisible] = useState(false);
    const [currentModel, setCurrentModel] = useState({});

    const openModal = (item) => {
        console.log('点击卡片，显示数据：', item);  // 看这里是否打印
        setCurrentModel(item);
        setModalVisible(true);
    };

    const closeModal = () => {
        setModalVisible(false);
    };

    return (
        <div className="app">
            {/* 头部导航栏 */}
            <Header />

            <div className="ai">
                <div className="ai-content">
                    <div className="section-header">
                        <h2>AI体验区</h2>
                        <p>私人定制的工作伙伴，百万级参数模型，深度理解您的需求！</p>
                    </div>
                </div>
                <div className="ai-content">
                    <div className="ai-segmented">
                        <Segmented size="large" options={segmentedOptions} onChange={handleSegmentedChange} />
                    </div>
                    <div className="ai-card">
                        {/* 正确：直接循环渲染 showData 数组 */}
                        {showData && showData.length > 0 ? (
                            showData.map((item, index) => (
                                <Card
                                    key={index}
                                    hoverable
                                    cover={
                                        <img draggable={false} alt={item.img_alt || "example"} src={item.img_url} />
                                    }
                                    onClick={() => openModal(item)}
                                >
                                    <Meta title={item.img_title} description={item.img_desc} />
                                </Card>
                            ))
                        ) : (
                            <div>暂无数据</div>
                        )}
                    </div>

                </div>
            </div>

            {/* 页脚 */}
            <Footer />

            {/* 直接用 props */}
            <AiModel
                visible={modalVisible}
                modelData={currentModel}
                onClose={closeModal}
            />
        </div>
    );
}

export default Ai;
